<template>
  <div class="modal fade show" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <form class="modal-content" @submit.prevent="applyFilters">
        <div class="modal-header">
          <h5 class="modal-title">Filtros de búsqueda</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="cancelFilter"></button>
        </div>
        <div v-if="loadingFiltersData" style="padding: 5ch 0;">
          <SpeenComponent  
            :isAutomatic="true" 
            :ringWidth="14" 
            :spinnerSize="15" 
            :isverticalAligned="true"
          />
        </div>
        <div class="modal-body" v-else>
          <label class="mb-1">Fecha de carga</label>
          <div class="row">
            <div class="col-6">
              <div class="input-box">
                <label for="from-date-input">Desde</label>
                <input id="from-date-input" type="date" class="form-control" v-model="fromDate" />
              </div>
            </div>
            <div class="col-6">
              <div class="input-box">
                <label for="to-date-input">Hasta</label>
                <input id="to-date-input" type="date" class="form-control" v-model="toDate" />
              </div>
            </div>
          </div>
          <div class="row">            
            <div class="input-box col-6">
              <label for="client" >Cliente</label>
              <select name="client" id="client" class="form-control" v-chosen="clientName" v-model="clientName">
                <option value="empty-client" selected disabled hidden></option>
                <option v-for="(client, index) in clientOptions" :key="index" :value="client.value">
                  {{ client.text }}
                </option>
              </select>
            </div>
            <div class="form-group input-box col-6">
              <label for="shipping-address-select">Dirección de envío</label>
              <select :key="shippingOptionsKey" class="form-control" name="shipping-address" id="shipping-address-select" v-chosen="shippingAddress" v-model="shippingAddress" :disabled="!isValidChosenClientOption">
                <option value="empty-client" selected disabled hidden></option>
                <option v-for="(address, index) in shippingOptions" :key="index" :value="address.value">
                  {{ address.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="input-box">
            <label for="reference" >Artículo</label>
            <select name="reference" id="reference" class="form-control" v-chosen="referenceId" v-model="referenceId">
              <option value="empty-reference" selected disabled hidden></option>
              <option v-for="(reference, index) in referenceOptions" :key="index" :value="reference.value">
                {{ reference.text }}
              </option>
            </select>
          </div>
          <div class="row">
            <div class="input-box col-6">
              <div class="d-flex justify-content-between align-items-center">
                <label for="order-name-input" >Orden de producción</label>
                <span class="mdi mdi-information-outline filter-info-icon" @click="toggleOrderProdTooltip()">
                  <Tooltip
                    v-if="showOrderNameTooltip"
                    :tooltipTextProp="tooltipText"
                  ></Tooltip>
                </span>
              </div>
              <input id="order-name-input" type="text" class="form-control" v-model="orderName" />
            </div>
            <div class="input-box col-6">
              <div class="d-flex justify-content-between align-items-center">
                <label for="form-control-input" >Lote</label>
                <span class="mdi mdi-information-outline filter-info-icon" @click="toggleBatchTooltip()">
                  <Tooltip
                    v-if="showBatchTooltip"
                    :tooltipTextProp="tooltipText"
                  ></Tooltip>
                </span>
              </div>
              <input id="form-control-input" type="text" class="form-control" v-model="batchName" />
            </div>
          </div>
          <div class="input-box">
            <div class="d-flex justify-content-between align-items-center">
              <label for="variety-name-input" >Variedad</label>
              <span class="mdi mdi-information-outline filter-info-icon" @click="toggleVarietyTooltip()">
                <Tooltip
                  v-if="showVarietyTooltip"
                  :tooltipTextProp="tooltipText"
                ></Tooltip>
              </span>
            </div>
            <input id="variety-name-input" type="text" class="form-control" v-model="varietyName" />
          </div>
          <div class="form-group input-box" label="Líneas de producción">
            <span>Líneas de producción</span>
            <select
              class="form-control"
              v-model="selectedProductionLines"
              v-chosen="selectedProductionLines"
              multiple>
              <option value="" disabled hidden>Seleccione una opción</option>
              <option v-for="(line, index) in productionLineOptions"
                      :key="index"
                      :value="line.value">
                {{ line.text }}
              </option> 
            </select>
          </div>
          <div class="row">
            <div class="form-group col-8" label="Estado">
              <span>Estados</span>
              <div class="row">
                <div class="col">
                  <label class="form-check form-switch">
                    Pendiente
                    <input type="checkbox" v-model="showStPending" class="form-check-input">
                  </label>
                </div>
                <div class="col">
                  <label class="form-check form-switch">
                    En Cola
                    <input type="checkbox" v-model="showStQueue" class="form-check-input">
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="form-check form-switch">
                    En Producción
                    <input type="checkbox" v-model="showStProd" class="form-check-input">
                  </label>
                </div>
                <div class="col">
                  <label class="form-check form-switch">
                    Finalizado
                    <input type="checkbox" v-model="showStFinished" class="form-check-input">
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group col-4" label="Ver solo órdenes de stock">
              <span>Órdenes de stock</span>
              <div class="row">
                <div class="col">
                  <label class="form-check form-switch">
                    <input type="checkbox" v-model="showOnlyStockOrders" class="form-check-input">
                    <span class="form-check-label">Solo órdenes de stock</span>
                  </label>
                  <label class="form-check form-switch">
                    <input type="checkbox" v-model="showOnlyNonStockOrders" class="form-check-input">
                    <span class="form-check-label">Solo órdenes no de stock</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="d-flex justify-content-end gap-1">
            <button type="button" class="btn btn-primary" @click="clearFilter">Restablecer filtros</button>
            <button type="button" class="btn btn-danger" @click="cancelFilter">Cancelar</button>
            <button type="submit" class="btn btn-success">Aplicar Filtros</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert } from '../../common/utils';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import Tooltip from '../components/Tooltip.vue';

export default {
  name: 'OrderReferenceIndexFilter',
  components: {
    SpeenComponent,
    Tooltip 
  },
  props: {
    applyFiltersProp:       { type: Function, required: true  },
    loadFiltersProp:        { type: Function, required: true  },
    filtersProp:            { type: Object,   required: false, default: () => {} },
  },
  data() {
    return {
      fromDate: this.filtersProp.cargo_date_from,
      toDate: this.filtersProp.cargo_date_to,
      clientName: this.filtersProp.client_name,
      shippingAddress: this.filtersProp.shipping_address,
      referenceId: this.filtersProp.reference_id,
      orderName: this.filtersProp.orderName,
      batchName: this.filtersProp.batchName,
      varietyName: this.filtersProp.varietyName,
      selectedProductionLines: this.filtersProp.production_lines,
      showStPending: this.filtersProp.showStPending,
      showStQueue: this.filtersProp.showStQueue,
      showStProd: this.filtersProp.showStProd,
      showStFinished: this.filtersProp.showStFinished,
      showOnlyStockOrders: this.filtersProp.showOnlyStockOrders,
      showOnlyNonStockOrders: this.filtersProp.showOnlyNonStockOrders,
      clientData: [],
      clientOptions: [],
      shippingOptions: [],
      referenceOptions: [],
      productionLineOptions: [],
      loadingFiltersData: false,
      loadingShippingOptions: false,
      isValidChosenClientOption: false,
      showOrderNameTooltip: false,
      showBatchTooltip: false,
      showVarietyTooltip: false,
      tooltipText : 'El sistema busca si lo que escribes aparece en cualquier parte del texto'
    };
  },
  computed: {
    shippingOptionsKey() {
      return this.shippingOptions.length + '-' + this.shippingAddress;
    }
  },
  methods: {
    handleFilters(){
      let filters = {
        cargo_date_from: this.fromDate,
        cargo_date_to: this.toDate,
        client_name: this.clientName ?? '',
        shipping_address: this.shippingAddress ?? '',
        reference_id: parseInt(this.referenceId ?? -1),
        orderName: this.orderName,
        batchName: this.batchName,
        varietyName: this.varietyName,
        production_lines: this.selectedProductionLines,
        showStPending: this.showStPending,
        showStQueue: this.showStQueue,
        showStProd: this.showStProd,
        showStFinished: this.showStFinished,
        showOnlyStockOrders: this.showOnlyStockOrders,
        showOnlyNonStockOrders: this.showOnlyNonStockOrders,
      };
      this.saveFilters(filters);
      return filters;
    },
    applyFilters() {
      let filters = this.handleFilters();
      this.applyFiltersProp(filters);
      this.cancelFilter(); 
    },
    cancelFilter() {
      this.$emit('closeFilterModal');
    },
    saveFilters(filters){
      sessionStorage.setItem('filters', JSON.stringify(filters));
      this.loadFiltersProp();
    },
    clearFilter(){
      const today = new Date();
      const past = new Date(today);
      past.setDate(today.getDate() - 7);
      const future = new Date(today);
      future.setDate(today.getDate() + 7);
      this.fromDate = this.formatDate(past);
      this.toDate = this.formatDate(future);
      this.clientName = "";
      this.shippingAddress = "";
      this.referenceId = -1;
      this.orderName = "";
      this.batchName = "";
      this.varietyName = "";
      this.selectedProductionLines = [];
      this.showStPending = true;
      this.showStQueue = true;
      this.showStProd = true;
      this.showStFinished = false;
      this.showOnlyStockOrders = false;
      this.showOnlyNonStockOrders = false;
      this.handleFilters();
      this.$nextTick(() => {
        setTimeout(() => {
          $("#client").val('').trigger("chosen:updated");
          $("#shipping-address-select").val('').trigger("chosen:updated");
          $("#reference").val('').trigger("chosen:updated");
          $("#production-line-select").val('').trigger("chosen:updated");
        }, 50);
      });
    },
    formatDate(d) {
      const year = d.getFullYear();
      let month = d.getMonth() + 1;
      let day = d.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      return `${year}-${month}-${day}`;
    },
    getOptionsData() {
      this.loadingFiltersData = true;
      this.getReferenceOptionsData();
      this.getProductionLineOptionsData();
      this.getClientOptionsData();
      setTimeout(() => {
        this.loadingFiltersData = false;
      }, 1000);
    },
    getReferenceOptionsData() {
      axios.get('/api/reference/combo')
        .then(response => {
          this.referenceOptions = response.data.referenceOptions.map(reference => ({
            value: reference.referenceId,
            text: reference.referenceName
          }));
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data)
          console.error('Error fetching reference options data:', error);
        });
    },
    getProductionLineOptionsData() {
      axios.get('/api/production-line/combo')
        .then(response => {
          this.productionLineOptions = response.data.productionLineOptions.map(line => ({
            value: line.productionLineId,
            text: line.productionLineCode
          }));
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data)
          console.error('Error fetching production line options data:', error);
        });
    },
    getClientOptionsData() {
      axios.get('/api/client/combo')
        .then(response => {
          this.clientData = response.data.clientOptions;
          this.clientOptions = response.data.clientOptions.map(client => ({
            value: client.clientName,
            text: client.clientName
          }));
          if (this.clientName) {
            this.updateShippingOptions();
          }
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data)
          console.error('Error fetching client options data:', error);
        });
    },
    cleanShippingAddressAndOptions() {
      this.shippingAddress = null;
      this.isValidChosenClientOption = false;
      $("#shipping-address-select").val('').trigger("chosen:updated");
    },
    updateShippingOptions() {
      if (!this.clientName) {
        this.cleanShippingAddressAndOptions();
        return;
      }
      const client = this.clientData.find(client => client.clientName == this.clientName);
      if (!client) {
        this.cleanShippingAddressAndOptions();
        return;
      }
      this.loadingShippingOptions = true;
      this.shippingOptions = client.shippingOptions.map(option => ({
        value: option.shippingOption,
        text: option.shippingOption
      }));
      this.isValidChosenClientOption = true;
      this.$nextTick(() => {
        setTimeout(() => {
          $("#shipping-address-select").val(this.shippingAddress || '').trigger("chosen:updated");
          this.loadingShippingOptions = false;
        }, 50);
      });
    },
    updateIsValidChosenClientOption() {
      this.isValidChosenClientOption = this.clientName != null && this.clientName != undefined && this.clientName != '';
    },
    toggleOrderProdTooltip() {
      this.showOrderNameTooltip = !this.showOrderNameTooltip;
      this.showBatchTooltip = false;
      this.showVarietyTooltip = false;
    },
    toggleBatchTooltip() {
      this.showBatchTooltip = !this.showBatchTooltip;
      this.showOrderNameTooltip = false;
      this.showVarietyTooltip = false;
    },
    toggleVarietyTooltip() {
      this.showVarietyTooltip = !this.showVarietyTooltip;
      this.showOrderNameTooltip = false;
      this.showBatchTooltip = false;
    },
  },
  watch: {
    clientName() {
      this.updateShippingOptions();
    },
    showOnlyStockOrders(newValue) {
      console.log('showOnlyStockOrders', newValue);
      this.showOnlyStockOrders = newValue;
      if(newValue) {
        this.showOnlyNonStockOrders = false;
      }
    },
    showOnlyNonStockOrders(newValue) {
      console.log('showOnlyNonStockOrders', newValue);
      this.showOnlyNonStockOrders = newValue;
      if(newValue) {
        this.showOnlyStockOrders = false;
      }
    },
  },
  mounted() {
    this.getOptionsData();
  },
};
</script>

<style lang="scss" scoped>

  .filter-info-icon {
    cursor: pointer;
    font-size: 1.2rem;
    color: #007bff;
    margin-right: 5px;
  }

  .input-box {
    margin-bottom: 1ch;
    & > :first-child {
      margin-bottom: 5px;
    }
  }

</style>
